import React from 'react';
import { useDispatch } from '../../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';
import { keyBoardAccessibilityAttributes } from '../../../../../../utils/GeneralUtils';
import ChrLink from '../../../../../generic/Utils/ChrLink';
import InnerHTML from '../../../../../generic/Utils/InnerHtml';
import Ibox from '../../../../../Ibox';
import BadgeList from '../../../templates/BadgeList';
import Image from './Image';
import Description from './Description';
import RightPane from './RightPane';
import GuestListUpdate from './GuestListUpdate';

const Card = ({ eventDetails, showQuickViewOnClick }) => {
  const dispatch = useDispatch();
  const linkAttributes = {};

  if(showQuickViewOnClick){
    linkAttributes['data-id'] = eventDetails.id;
    linkAttributes.onClick = event => {
      event.preventDefault();
      const eventId = event.target.dataset?.id || event.target.parentElement.dataset?.id;
      dispatch(eventsListingActions.setQuickViewEventId(eventId));
    };
  }
  linkAttributes.href = eventDetails.url;
  const setAccessibilityAttributes = linkAttributes.onClick || linkAttributes.href;

  return(
    <Ibox iboxClass="mb-4" iboxContentClass='p-m'>
      <div className='d-flex flex-column mx-0'>
        <div className='row mx-0'>
          <Image
            linkAttributes={ linkAttributes }
            image={ eventDetails.image }
            setAccessibilityAttributes={ setAccessibilityAttributes }
          />
          <div className="col-12 col-sm w-100 row pr-0 cui-event-details">
            <div className={ `col-12 ${ eventDetails.showRightPaneContent ? 'col-md-8' : '' } d-flex flex-column px-2` }>
              <BadgeList badges={ eventDetails.badges }/>
              <ChrLink className="text-primary mt-1"
                { ...linkAttributes }
                { ...(setAccessibilityAttributes && keyBoardAccessibilityAttributes) }
              >
                <h3 className="mb-1 break-word">{ eventDetails.title }</h3>
              </ChrLink>
              { eventDetails.hostedBy && <InnerHTML content={ eventDetails.hostedBy } containerClass='text-muted mb-2 break-word'/> }
              { eventDetails.description && <Description description={ eventDetails.description } linkAttributes={ linkAttributes } showRightPaneContent={ eventDetails.showRightPaneContent } /> }
            </div>
            { eventDetails.showRightPaneContent && <RightPane eventDetails={ eventDetails } /> }
          </div>
        </div>
        {
          eventDetails.updateGuestListInfo && <GuestListUpdate
            id={ eventDetails.id }
            updateGuestList={ eventDetails.updateGuestListInfo }
          />
        }
      </div>
    </Ibox>
  )
}

export default Card;